import {useState} from 'react';
import {getPublicSearchLimit} from 'api/common';
import {alertByError} from 'utils/alerts';
import Cookies from 'utils/cookies';

function useGetPublicLimit(verifyCaptcha) {
  const [limit, setLimit] = useState();
  const [isLoading, setIsLoading] = useState(false);

  async function getLimit() {
    try {
      setIsLoading(true);
      const limit = await getPublicSearchLimit();

      setLimit(limit);
    } catch (e) {
      document.activeElement.blur();
      if (e.status === 429) {
        Cookies.captchaToken = '';
        await alertByError(e);
      } else {
        if (e.code === 'invalid_captcha_token') {
          verifyCaptcha();
        }
      }
    } finally {
      setIsLoading(false);
    }
  }

  return {limit, isLoading, getLimit};
}

export default useGetPublicLimit;
